module.exports = __webpack_public_path__ + "img/about-card-info.6c5f1230.png";